module.exports = __webpack_public_path__ + "img/secKillDialog.9a18eb6e.png";